// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"autocomplete":1,"clinic-profile":1,"booking":1,"book-treatment":1}[chunkId]) return "js/admin/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};